export function getNewMeetLink(id = '') {
    return `/new-meet/${id}`
}
